import React, { useContext, useState, useEffect } from 'react';
import LogCard from './../components/LogCard';
import { WebSocketContext } from "../WebSocketContext";
import './../Trades.css';
import { Refresh } from '@mui/icons-material';
import { apiAppFetch } from '../utils/apiFetch';

const RejectionLogs = () => {

    const [rejectionLogs, setRejectionLogs] = useState([]);

    const getRejectionLogs = async () => {
        try 
        {  
          const response = await apiAppFetch('getTodayRejectionLog', {
            method: 'POST',
            body: JSON.stringify({ user_type: 'client' }),
          });
          
          const data = await response.json();
          
          setRejectionLogs(data); 

        } catch (error) {
          console.error('Error fetching rejection logs:', error);
        }
    };

    useEffect(() => {
        getRejectionLogs();
      }, []);

    const handleRefresh = () => {
        getRejectionLogs();
    };

  return (
    <div className="trades-page">
      
      <button className="refresh-button" onClick={handleRefresh}><Refresh /></button>
      
      {rejectionLogs.map(log => (
        <LogCard 
          key={log.id} 
          log={log} 
        />
      ))}
    </div>
  );
}

export default RejectionLogs;

